/**
 * @generated SignedSource<<4dac377d2ccac9e7a352e1fe9c9193a4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ParticipantFilterGroupQuery_Query$variables = {
  studyId: string;
};
export type ParticipantFilterGroupQuery_Query$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"ParticipantFilters_viewer">;
  };
};
export type ParticipantFilterGroupQuery_Query = {
  response: ParticipantFilterGroupQuery_Query$data;
  variables: ParticipantFilterGroupQuery_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "studyId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "studyId",
    "variableName": "studyId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  (v2/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "FilterNode",
  "kind": "LinkedField",
  "name": "filters",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "UserNode",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StudyNode",
      "kind": "LinkedField",
      "name": "study",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": null
    },
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filters",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dbId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v10 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v11 = [
  (v7/*: any*/),
  (v9/*: any*/),
  (v2/*: any*/)
],
v12 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CharacteristicNode",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CharacteristicAnswerNode",
        "kind": "LinkedField",
        "name": "answers",
        "plural": true,
        "selections": (v11/*: any*/),
        "storageKey": null
      },
      (v7/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "CharacteristicRowNode",
        "kind": "LinkedField",
        "name": "rows",
        "plural": true,
        "selections": (v11/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "shortName",
        "storageKey": null
      },
      (v5/*: any*/),
      (v2/*: any*/)
    ],
    "storageKey": null
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ParticipantFilterGroupQuery_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "FragmentSpread",
            "name": "ParticipantFilters_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ParticipantFilterGroupQuery_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ScreenerNode",
                "kind": "LinkedField",
                "name": "screener",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ElementNodeConnection",
                    "kind": "LinkedField",
                    "name": "elements",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ElementNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ElementNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v5/*: any*/),
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "label",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AnswerNodeConnection",
                                "kind": "LinkedField",
                                "name": "answers",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AnswerNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AnswerNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v8/*: any*/),
                                          (v9/*: any*/),
                                          (v7/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RowNodeConnection",
                                "kind": "LinkedField",
                                "name": "rows",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RowNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RowNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v7/*: any*/),
                                          (v9/*: any*/),
                                          (v8/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SegmentNodeConnection",
                    "kind": "LinkedField",
                    "name": "segments",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SegmentNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SegmentNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v7/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TenantNode",
                    "kind": "LinkedField",
                    "name": "tenant",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": (v10/*: any*/),
                        "concreteType": "CharacteristicNodeConnection",
                        "kind": "LinkedField",
                        "name": "characteristics",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CharacteristicNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": (v12/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": "characteristics(first:1000)"
                      },
                      {
                        "alias": null,
                        "args": (v10/*: any*/),
                        "concreteType": "TenantGlobalCharacteristicsConnection",
                        "kind": "LinkedField",
                        "name": "globalCharacteristics",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TenantGlobalCharacteristicsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": (v12/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": "globalCharacteristics(first:1000)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TagNode",
                        "kind": "LinkedField",
                        "name": "tags",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "color",
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          (v2/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StudyNode",
                        "kind": "LinkedField",
                        "name": "studiesLaunched",
                        "plural": true,
                        "selections": [
                          (v13/*: any*/),
                          (v3/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "39dd1c694cfbc2379c47b2e9a9e364ed",
    "id": null,
    "metadata": {},
    "name": "ParticipantFilterGroupQuery_Query",
    "operationKind": "query",
    "text": "query ParticipantFilterGroupQuery_Query(\n  $studyId: String!\n) {\n  viewer {\n    ...ParticipantFilters_viewer_1veGAH\n  }\n}\n\nfragment DrawerFilters_viewer_1veGAH on Viewer {\n  study(studyId: $studyId) {\n    id\n    filters {\n      id\n      name\n      user {\n        id\n      }\n      study {\n        id\n      }\n      type\n      filters\n    }\n    screener {\n      ...InputFilterGroupGroup_screener\n      id\n    }\n  }\n  user {\n    id\n    profile {\n      tenant {\n        id\n        name\n        filters {\n          id\n          name\n          user {\n            id\n          }\n          study {\n            id\n          }\n          type\n          filters\n        }\n        ...InputFilterGroupGroup_tenant\n      }\n      id\n    }\n  }\n}\n\nfragment InputFilterGroupGroup_screener on ScreenerNode {\n  id\n  ...InputFilterGroup_screener\n}\n\nfragment InputFilterGroupGroup_tenant on TenantNode {\n  id\n  ...InputFilterGroup_tenant\n}\n\nfragment InputFilterGroup_screener on ScreenerNode {\n  id\n  ...InputFilter_screener\n}\n\nfragment InputFilterGroup_tenant on TenantNode {\n  id\n  ...InputFilter_tenant\n}\n\nfragment InputFilterStudyFilter_tenant on TenantNode {\n  tags {\n    color\n    dId\n    id\n    name\n  }\n  studiesLaunched {\n    dId\n    name\n    id\n  }\n}\n\nfragment InputFilter_screener on ScreenerNode {\n  id\n  elements {\n    edges {\n      node {\n        id\n        dbId\n        position\n        type\n        text\n        label\n        answers {\n          edges {\n            node {\n              id\n              position\n              text\n              dbId\n            }\n          }\n        }\n        rows {\n          edges {\n            node {\n              id\n              dbId\n              text\n              position\n            }\n          }\n        }\n      }\n    }\n  }\n  segments {\n    edges {\n      node {\n        id\n        dbId\n        text\n      }\n    }\n  }\n}\n\nfragment InputFilter_tenant on TenantNode {\n  characteristics(first: 1000) {\n    edges {\n      node {\n        answers {\n          dbId\n          text\n          id\n        }\n        dbId\n        rows {\n          dbId\n          text\n          id\n        }\n        shortName\n        type\n        id\n      }\n    }\n  }\n  globalCharacteristics(first: 1000) {\n    edges {\n      node {\n        answers {\n          dbId\n          text\n          id\n        }\n        dbId\n        rows {\n          dbId\n          text\n          id\n        }\n        shortName\n        type\n        id\n      }\n    }\n  }\n  ...InputFilterStudyFilter_tenant\n}\n\nfragment ParticipantFilters_viewer_1veGAH on Viewer {\n  study(studyId: $studyId) {\n    id\n    filters {\n      id\n      name\n      user {\n        id\n      }\n      study {\n        id\n      }\n      type\n      filters\n    }\n  }\n  user {\n    id\n    profile {\n      tenant {\n        id\n        name\n        filters {\n          id\n          name\n          user {\n            id\n          }\n          study {\n            id\n          }\n          type\n          filters\n        }\n      }\n      id\n    }\n  }\n  ...DrawerFilters_viewer_1veGAH\n}\n"
  }
};
})();

(node as any).hash = "8dd29cc30c5f6f93bc477b22a029b269";

export default node;
